import { useTranslation } from "@l2r-front/l2r-i18n"
import { BottomSheetContent } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

import { RoadwaySidebarContent } from "../RoadwaySidebarContent"

export function RoadwaySidebar() {

    const { t } = useTranslation([I18N_NAMESPACE])

    return (
        <BottomSheetContent id="roadway-sidebar" title={t(I18N_NAMESPACE, "containers.roadwaySidebar.title")}>
            <RoadwaySidebarContent />
        </BottomSheetContent>
    )
}
